import { render, staticRenderFns } from "./InputTextProjectAreaNote.vue?vue&type=template&id=ea65f9b0&scoped=true"
import script from "./InputTextProjectAreaNote.vue?vue&type=script&lang=js"
export * from "./InputTextProjectAreaNote.vue?vue&type=script&lang=js"
import style0 from "./InputTextProjectAreaNote.vue?vue&type=style&index=0&id=ea65f9b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea65f9b0",
  null
  
)

export default component.exports